import { FC, useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { datadogRum } from '@datadog/browser-rum';
import parseJwt from '../../../services/utils/parseJwt';
import AuthService from '../../../services/auth/authService';

const DatadogUserTagger: FC = () => {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { userLoggedIn } = useSelector((state: any) => state.user, shallowEqual);
  const [{ id, organization, role }, setDataDogValues] = useState({ id: '', organization: '', role: '' });
  useEffect(() => {
    if (userLoggedIn && AuthService.authTokenExists()) {
      const token = AuthService.getAuthToken();
      const jwt = parseJwt(token);
      setDataDogValues({
        id: jwt.sub,
        organization: jwt.profile.organization,
        role: jwt.profile.role,
      });
    }
  }, [userLoggedIn]);

  useEffect(() => {
    datadogRum.setUser({ id, organization, role });
  }, [id, organization, role]);
  return <span></span>;
};

export default DatadogUserTagger;
